export default __webpack_public_path__ + "static/media/news2.6d98cb44.jpg";